<div class="card mb-4">
    <div class="card-body">
      <h5 class="card-title text-center"> All Orders</h5>
      
      <!-- Excel Export Button and Date Range Filter in One Row -->
  <!-- Excel Export Button and Date Range Filter in One Row -->
  <div class="row mb-3 align-items-center">
  
      <!-- Status Filter -->
      <div class="col-auto">
        <label for="statusFilter" class="form-label">Order Wise</label>
        <select id="statusFilter" class="form-control" [(ngModel)]="statusFilter" (change)="applyFilters()">
          <option value="">All</option>
          <option value="ticketGenerated">New Order</option>
          <option value="Repeated Order">Repeated Order</option>
        </select>
      </div>
    <!-- From Date -->
    <div class="col-auto">
      <label for="fromDate" class="form-label">From Date</label>
      <input type="date" id="fromDate" class="form-control" [(ngModel)]="fromDate" (change)="applyFilters()">
    </div>
  
    <!-- To Date -->
    <div class="col-auto">
      <label for="toDate" class="form-label">To Date</label>
      <input type="date" id="toDate" class="form-control" [(ngModel)]="toDate" (change)="applyFilters()">
    </div>
  

  
    <!-- Search Filters -->
    <div class="col-auto">
      <label for="refNoFilter" class="form-label">Ref No</label>

      <input type="text" class="form-control" [(ngModel)]="refNoFilter" (input)="applyFilters()" placeholder="Search by Ref No">
    </div>
    <div class="col-auto">
      <label for="poNoFilter" class="form-label">Po No</label>

      <input type="text" class="form-control" [(ngModel)]="poNoFilter" (input)="applyFilters()" placeholder="Search by PO No">
    </div>
    <div class="col-auto">
      <label for="jobNameFilter" class="form-label">Job Name</label>

      <input type="text" class="form-control" [(ngModel)]="jobNameFilter" (input)="applyFilters()" placeholder="Search by Job Name">
    </div>
    <!-- <div class="col-auto">
      <label for="clientNameFilter" class="form-label">Client Name</label>

      <input type="text" class="form-control" [(ngModel)]="clientNameFilter" (input)="applyFilters()" placeholder="Search by Customer">
    </div> -->
  <div class="col-3">
  <label for="clientNameFilter" class="form-label">Client Name</label>
  <ng-select
    [items]="clientList"
    bindLabel=""
    bindValue=""
    [(ngModel)]="clientNameFilter"
    placeholder="Select Client"
    (change)="applyFilters()"
    [clearable]="true">
  </ng-select>
</div>


    <div class="col-auto">
      <label for="ticketNoFilter" class="form-label">Ticket No</label>

      <input type="text" class="form-control" [(ngModel)]="ticketNoFilter" (input)="applyFilters()" placeholder="Search by Ticket No">
    </div>
      <!-- Export Button -->
      <div class="col-auto">
        <button class="highlight-link" (click)="exportToExcel()">Export to Excel</button>
      </div>
  </div>
  
  
      <!-- Table -->
      <div class="table-responsive" style="max-height: 900px; overflow-y: auto;">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Preview
                <!--  (click)="sortTable('dispatch')"<span *ngIf="currentSortColumn === 'dispatch'">
                  <i [class]="'feather icon-arrow-' + (currentSortDirection === 'asc' ? 'up' : 'down')" class="sort-arrow"></i>
                </span> -->
              </th>
              <th>Date</th>
              <th>Order Type</th>
              <th>Ticket No</th>
              <th>Ref No</th>
              <th>PO Number</th>
              <th>Customer</th>
              <th>Job Name</th>
              <th>Total Order(kg)</th>
              <th>Pcs</th>
              <th>Total Dispatch</th>
              <th>Remain Bal</th>
              <th>Disp Status</th>

            </tr>
          </thead>
          <tbody>
            <!-- <tr *ngFor="let dispatch of filteredDispatches"> -->
              <tr *ngFor="let dispatch of paginatedDispatches">

              <td>
                <button class="highlight-link" (click)="previewOrder(dispatch)">Preview</button>
              </td>
              <td>{{ dispatch.created | date }}</td>
              <td [ngStyle]="{
                color: dispatch.status === 'Repeated Order' ? 'red' :
                          dispatch.status === 'ticketGenerated' ? 'blue' : 'black'
                  }">
                {{
                  dispatch.status === 'ticketGenerated' ? 'New Order' :
                  dispatch.status === 'Repeated Order' ? 'Repeated Order' :
                  'Unknown'
                }}
              </td>
              <td>{{ dispatch.ticketno }}</td>
              <td>{{ dispatch.refNo }}</td>
              <td>{{ dispatch.poNo }}</td>
              <td>{{ dispatch.clientName }}</td>
              <td>{{ dispatch.jobName }}</td>
              <td>{{ dispatch.orderKgs | number:'1.2-2':'en-US' }}</td>
              <!-- <td>{{ dispatch.orderPcs | number:'1.0-0':'en-US'}}</td> -->
              <td>{{ getNumber(dispatch.orderPcs) | number:'1.0-0':'en-US' }}</td>
              <td>{{ dispatch.jssfolderno || 0 }}</td>
              <td>{{ dispatch.jobType || 0 }}</td>
              <td [ngClass]="{
                
                    'text-primary': dispatch.LamType === 'Open',
                    'text-success': dispatch.LamType === 'Closed',
                    'text-warning': dispatch.LamType === 'Pending'
                  }">
                  {{ dispatch.LamType === 'Pending' || dispatch.LamType === null ? 'Pending' : dispatch.LamType }}
              </td>
            </tr>
            <tr *ngIf="filteredDispatches.length === 0">
              <td colspan="8" class="text-center">No dispatches available</td>
            </tr>
          </tbody>
        </table>



        <div class="pagination-container mt-3">
          <div class="pagination d-flex justify-content-between align-items-center">
            <!-- Showing range -->
            <div>
              <p>Showing {{ calculateRangeStart() }} - {{ calculateRangeEnd() }} of {{ pageTotalItem }}</p>
            </div>
        
            <!-- Pagination controls -->
            <div class="d-flex align-items-center">
              <!-- Prev -->
              <a 
                class="pagination-btn pt-2 me-2" 
                (click)="onPageChange(page - 1)"
                [ngClass]="{'disabled': page === 1}">
                <i class="feather icon-chevrons-left"></i>
              </a>
        
              <!-- Page number display -->
              <span class="pagination-page-number">
                {{ page }}
              </span>
        
              <!-- Next -->
              <a 
                class="pagination-btn  pt-2 ms-2"
                (click)="onPageChange(page + 1)"
                [ngClass]="{'disabled': page === ceil(pageTotalItem / limit)}">
                <i class="feather icon-chevrons-right"></i>
              </a>
            </div>
          </div>
        </div>
        
      </div>
    </div>
  </div>
  

  
              <!-- <th (click)="sortTable('created')">Date
                <span *ngIf="currentSortColumn === 'created'">
                  <i [class]="'feather icon-arrow-' + (currentSortDirection === 'asc' ? 'up' : 'down')" class="sort-arrow"></i>
                </span>
              </th>
               <th (click)="sortTable('status')">Order Type
                <span *ngIf="currentSortColumn === 'status'">
                  <i [class]="'feather icon-arrow-' + (currentSortDirection === 'asc' ? 'up' : 'down')" class="sort-arrow"></i>
                </span>
              </th>

              <th (click)="sortTable('ticketno')">Ticket No
                <span *ngIf="currentSortColumn === 'ticketno'">
                  <i [class]="'feather icon-arrow-' + (currentSortDirection === 'asc' ? 'up' : 'down')" class="sort-arrow"></i>
                </span>
              </th>
              <th (click)="sortTable('refNo')">Ref No
                <span *ngIf="currentSortColumn === 'refNo'">
                  <i [class]="'feather icon-arrow-' + (currentSortDirection === 'asc' ? 'up' : 'down')" class="sort-arrow"></i>
                </span>
              </th>
              <th (click)="sortTable('poNo')">PO Number
                <span *ngIf="currentSortColumn === 'poNo'">
                  <i [class]="'feather icon-arrow-' + (currentSortDirection === 'asc' ? 'up' : 'down')" class="sort-arrow"></i>
                </span>
              </th>
              <th (click)="sortTable('clientName')">Customer
                <span *ngIf="currentSortColumn === 'clientName'">
                  <i [class]="'feather icon-arrow-' + (currentSortDirection === 'asc' ? 'up' : 'down')" class="sort-arrow"></i>
                </span>
              </th>
              <th (click)="sortTable('jobName')">Job Name
                <span *ngIf="currentSortColumn === 'jobName'">
                  <i [class]="'feather icon-arrow-' + (currentSortDirection === 'asc' ? 'up' : 'down')" class="sort-arrow"></i>
                </span>
              </th>
              <th (click)="sortTable('orderKgs')">Total Order(kg)
                <span *ngIf="currentSortColumn === 'orderKgs'">
                  <i [class]="'feather icon-arrow-' + (currentSortDirection === 'asc' ? 'up' : 'down')" class="sort-arrow"></i>
                </span>
              </th>
              <th (click)="sortTable('orderPcs')">Pcs
                <span *ngIf="currentSortColumn === 'orderPcs'">
                  <i [class]="'feather icon-arrow-' + (currentSortDirection === 'asc' ? 'up' : 'down')" class="sort-arrow"></i>
                </span>
              </th>
              <th (click)="sortTable('totalDispatched')">Total Dispatch
                <span *ngIf="currentSortColumn === 'totalDispatched'">
                  <i [class]="'feather icon-arrow-' + (currentSortDirection === 'asc' ? 'up' : 'down')" class="sort-arrow"></i>
                </span>
              </th>
              <th (click)="sortTable('kgsBal')">Remain Bal
                <span *ngIf="currentSortColumn === 'kgsBal'">
                  <i [class]="'feather icon-arrow-' + (currentSortDirection === 'asc' ? 'up' : 'down')" class="sort-arrow"></i>
                </span>
              </th>
              <th (click)="sortTable('status')">Disp Status
                <span *ngIf="currentSortColumn === 'status'">
                  <i [class]="'feather icon-arrow-' + (currentSortDirection === 'asc' ? 'up' : 'down')" class="sort-arrow"></i>
                </span>
              </th> -->
           